import { z } from "zod";

export const MergeTbaIntoBookRequestSchema = z.object({
    targetBookId: z.string().min(1),
    tbaBookId: z.string().min(1),
    votingPeriodId: z.string().min(1).optional(),
});

export type MergeTbaIntoBookRequest = z.infer<typeof MergeTbaIntoBookRequestSchema>;

export const MergeTbaIntoBookResponseSchema = z.object({
    alreadyMerged: z.boolean().optional(),
    attendanceUpdated: z.number().int().min(0),
    month: z.number().int().min(1).max(12),
    sessionsUpdated: z.number().int().min(0),
    success: z.literal(true),
    targetBookId: z.string(),
    votingPeriodClosed: z.boolean().optional(),
    year: z.number().int(),
});

export type MergeTbaIntoBookResponse = z.infer<typeof MergeTbaIntoBookResponseSchema>;
